export const questions: Array<[string, string]> = [
  [
    'Who is this for?',
    'Maintenance technicians, industrial mechanics, hydraulic and pneumatic technicians, millwrights, electricians who work on machines, plant engineers and engineering students.',
  ],
  ['What format is it?', 'Downloadable PDF volumes you can read on any device or print.'],
  ['How do I receive it?', 'Instant access by email right after payment.'],
  [
    'Do I need previous experience?',
    'No. Volume 01 starts from the fundamentals and the volumes progress to advanced topics.',
  ],
  [
    'Does it cover both hydraulics and pneumatics?',
    'Yes: hydraulics in Volumes 02–04, pneumatics in Volume 05, and maintenance, troubleshooting and safety for both in Volume 06.',
  ],
  ['Is there a guarantee?', 'Yes, 7 days.'],
];
